class PredictiveSearch extends HTMLElement {
  constructor() {
		super();

    this.siteId = 'zcq50k';
    this.form = this.querySelector('[js-predictive-search-form]');
    this.input = this.querySelector('input[type="search"]');
    this.searchResultsWrapper = this.querySelector('[js-predictive-search-results-wrapper]');
    this.searchResultsList = this.querySelector('[js-predictive-search-results-list]');
		this.predictiveSearchSuggestions = this.querySelector('[js-predictive-search-suggestions]');
    this.defaultSuggestionsList = this.querySelector('[js-predictive-search-default-suggestions]');
    this.suggestionsWrapper = this.querySelector('[js-predictive-search-suggestions-wrapper]');
    this.suggestionsList = this.querySelector('[js-predictive-search-suggestions-list]');
		this.viewAll = this.querySelector('[js-link-view-all]');

    this.query = '';

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.form.addEventListener("submit", this.onSubmit);
  }

  onSubmit = (evt) => {
    evt.preventDefault();
    window.location.href = `/search?query=${this.query ? `${this.query}` : `${this.input.value}`}`;
  }

  onChange() {
    this.query = this.input.value;
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.searchResultsWrapper.classList.add('hidden');
      this.suggestionsWrapper.classList.add('hidden');
      return;
		}

    this.renderMarkup(searchTerm);
  }

	suggestionTrigger() {
    const suggestionTriggers = this.predictiveSearchSuggestions.querySelectorAll('[js-predictive-search-suggestion]');
    suggestionTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.getSearchProducts(evt.currentTarget.dataset.originalText, evt.currentTarget.dataset.suggestionText);
        suggestionTriggers.forEach((trigger) => {
          trigger.classList.remove('underline');
        });
        evt.currentTarget.classList.add('underline');
      })
    });
	}

	getCookie = (name) => {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts && parts.length === 2) {
			return parts.pop().split(';').shift();
		} else {
			return ''
		}
	};

	callSearchSpringPreflight = async () => {
		const personalizedParams = this.getPersonalizationParams();
		const url = `https://${this.siteId}.a.searchspring.io/api/personalization/preflightCache?shopper=${personalizedParams.shopper}&cart=${personalizedParams.cart}&lastViewed=${personalizedParams.lastViewed}`;
		const options = {method: 'GET'};
		const response = await fetch(url, options)
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
	}

	getTrackingParams = () => {
		return {
			userId: this.getCookie('ssUserId'),
			sessionId: this.getCookie('ssSessionIdNamespace'),
			pageLoadId: this.getCookie('pageLoadId'),
			domain: window.location.href
		};
	};

	getPersonalizationParams = () => {
		return {
			shopper: this.getCookie('ssUserId'),
			cart: this.getCookie('shopify_cart_products'),
			lastViewed: this.getCookie('shopify_last_viewed')
		};
	};

  renderMarkup(searchTerm) {
	  const searchResponse = async () => {
	    this.searchResultsList.innerHTML = '';
			if (!!this.viewAll) {
				if (this.query) {
					this.viewAll.classList.remove('hidden');
					this.viewAll.href = `/search?query=${this.query ? `${this.query}` : `${this.input.value}`}`;
				} else {
					this.viewAll.classList.add('hidden')
				}
			}

			const trackingParams = this.getTrackingParams();
			const personalizedParams = this.getPersonalizationParams();

			const baseParams = new URLSearchParams({
				siteId: this.siteId,
				...trackingParams,
				...personalizedParams,
			}).toString();


	    // Fetch URL Responses
	    const options = {method: 'GET', headers: {accept: 'application/json'}};
	    const fetchProducts = `https://${this.siteId}.a.searchspring.io/api/search/autocomplete.json?${baseParams}&resultsFormat=json&q=${searchTerm}&page=1&resultsPerPage=6&bgfilter.ss_is_published=1&redirectResponse=direct`;
	    const fetchSuggestions = `https://${this.siteId}.a.searchspring.io/api/suggest/query?${baseParams}&language=en&suggestionCount=6&productCount=20`;

			// Call SearchSpring Preflight
			await this.callSearchSpringPreflight().then().catch((error) => {
				console.error('Preflight Cache Error:', error);
			});

			const responses = await Promise.all([
				fetch(fetchProducts, options),
				fetch(fetchSuggestions, options),
			]).then(responses => {
				return Promise.all(responses.map(function (response) {
					return response.json();
				}));
			}).then(async response => {
				let productCardsMarkup = '';
				let suggestionsMarkup = '';

		    if (response[0].results && response[0].results.length > 0) {
					let productCardArray = new Array;
					var productCardFetches = [];

		      for (const product of response[0].results) {
						productCardFetches.push(
		      		fetch(`/products/${product.handle}/?view=product-card`)
		        		.then(response => response.text())
		        		.then((text) => {
		          		const html = text;
		          		const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
		          		const productCardCopy = parsedHTML.querySelector('[js-product-card-copy]').innerHTML;
		          		productCardArray.push(productCardCopy);
		        		})
		        )
		      }
					await Promise.all(productCardFetches).then(function() {
						for (const productCard of productCardArray) {
					    const productCardWrapper = `<li class="predictive-search__list-item" role="option">${productCard}</li>`;
					    productCardsMarkup = `${productCardsMarkup}${productCardWrapper}`
					  }
					});
				}

				if (response[1].suggested) {
					const replace = response[1].query;
          const replaceTo = `<b class="text-black">${response[1].query}</b>`;
          let afterReplace = response[1].suggested.text.replace(replace, replaceTo);

					suggestionsMarkup = `${suggestionsMarkup}
						<li class="predictive-search__suggestion-wrapper pt-16 desktop:pt-8">
							<a class="predictive-search__suggestion text-gray-true underline" href="/search?query=${encodeURIComponent(response[1].query)}" data-original-text="${response[1].query}" data-suggestion-text="${response[1].suggested.text}">${afterReplace}</a>
						</li>
					`;

					const altSuggestions = response[1].alternatives;
					altSuggestions.forEach((suggestion) => {
						afterReplace = suggestion.text.replace(replace, replaceTo);
						suggestionsMarkup = `${suggestionsMarkup}
							<li class="predictive-search__suggestion-wrapper pt-16 desktop:pt-8">
								<a class="predictive-search__suggestion text-gray-true" href="/search?query=${encodeURIComponent(suggestion.text)}" data-original-text="${response[1].query}" data-suggestion-text="${suggestion.text}">${afterReplace}</a>
							</li>
						`;
					});
				}

				return [productCardsMarkup, suggestionsMarkup];
			}).catch(function (error) {
				console.log(error);
			});

			const productCardsMarkup = responses[0];
			const suggestionsMarkup = responses[1];

			// Render product results
	    if (productCardsMarkup.length > 0) {
	    	if (!this.searchResultsList.classList.contains('active')) {
	    		this.searchResultsList.classList.add('active');
	    	}
	      this.searchResultsList.innerHTML = '';
	      this.searchResultsList.insertAdjacentHTML('beforeend', productCardsMarkup);
	     	this.searchResultsList.querySelectorAll('[js-product-card-loading]').forEach((loading) => {
	      	if (loading.hasAttribute('loading')) {
						setTimeout(() => {
							loading.removeAttribute('loading');
							loading.classList.add('!hidden');
						}, "500");
	      	}
	      });
	      this.searchResultsWrapper.classList.remove('hidden');
				this.searchResultsList.insertAdjacentHTML('beforeend', `<li class="li__view-all"><a class="link__view-all" href="/search?query=${searchTerm}">View All</a></li>`);
	    } else {
	    	if (this.searchResultsList.classList.contains('active')) {
	    		this.searchResultsList.classList.remove('active');
	    	}
	    	this.searchResultsList.classList.add('active');
	      this.searchResultsWrapper.classList.add('hidden');
	    }

			// Render suggestions
			if (suggestionsMarkup.length > 0 && productCardsMarkup.length > 0) {
				this.suggestionsList.innerHTML = '';
				this.suggestionsList.insertAdjacentHTML('beforeend', suggestionsMarkup);
				this.suggestionsWrapper.classList.remove('hidden');
			} else {
				this.suggestionsWrapper.classList.add('hidden');
			}
	  }

	  searchResponse();
  }
}

customElements.define("predictive-search", PredictiveSearch);
